import { api } from "./api";

export const gerarToken = async () => {
  try {
    const response = await api.get("/api/ServicoMonitorado/generate-token", {
      headers: {
        'ApiKey': 'jbmQL0NMmj'
      }
    });
    const token = response.data.token;
    localStorage.setItem("jwtToken", token);
    return token;
  } catch (error) {
    console.error("Erro ao gerar token:", error);
    throw error;
  }
};

export const getServicoMonitorado = async () => {
  try {
    const response = await api.get("/api/ServicoMonitorado/servicosMonitorados");
    return response.data;
  } catch (error) {
    console.error("Erro de rota ao buscar serviços monitorados:", error);
    throw error;
  }
};

export const getMonitoramentoBackup = async () => {
  try {
    const response = await api.get("/api/ServicoMonitorado/monitoramentoBackup");
    return response.data;
  } catch (error) {
    console.error("Erro de rota ao buscar monitoramento backup:", error);
    throw error;
  }
};

export const getHorusUrl = async () => {
  try {
    const response = await api.get("/api/Horus");
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar url:", error);
    throw error;
  }
};
